module.exports = __webpack_public_path__ + "static/media/marker-e.a8aa88d7.svg";